import { render } from "./trader-info.vue?vue&type=template&id=dfd70b12&scoped=true"
import script from "./trader-info.vue?vue&type=script&lang=js"
export * from "./trader-info.vue?vue&type=script&lang=js"

import "./trader-info.vue?vue&type=style&index=0&id=dfd70b12&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd70b12"]])

export default __exports__